<template>
  <div class="stk-p-8">
    <FundDetailView
      back-to="/advisor/fund-screener"
      :values="parsedValues"
    />
  </div>
</template>

<script>
import FundDetailView from '@frontend/dash3/js/views/FundDetailView.vue';

export default {
  components: {
    FundDetailView,
  },
  props: ['values'],
  computed: {
    parsedValues() {
      // If we have metricIds from query params, create a minimal values structure for highlighting
      if (this.$route.query.metricIds) {
        try {
          const metricIds = JSON.parse(this.$route.query.metricIds);
          return [{
            name: 'Selected Values',
            metrics: metricIds.map(id => ({ metric_description: id }))
          }];
        } catch (e) {
          console.warn('Failed to parse metricIds from query params:', e);
        }
      }
      
      // Try to get full values from query params (legacy support)
      if (this.$route.query.values) {
        try {
          return JSON.parse(this.$route.query.values);
        } catch (e) {
          console.warn('Failed to parse values from query params:', e);
        }
      }
      
      return this.values || [];
    }
  }
};
</script>

